import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
import { Button, Group } from 'react-aria-components';
export function DatePickerButton({ children, className }) {
    return (_jsx(Group, { children: _jsx(Button, { className: cn('p-stack-tight hover:bg-bg-subtle rounded-control text-fg-muted focus:outline-border-focus', className), children: children }) }));
}
